// extracted by mini-css-extract-plugin
export var basic = "style-module--basic--y+vux";
export var menu = "style-module--menu--Wuq3X";
export var search = "style-module--search--ldpDm";